/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Featured_Metadescription1Inputs */

const zh_featured_metadescription1 = /** @type {(inputs: Featured_Metadescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从数学动画到英语游戏，AI 助手帮助老师们打造了各种创新教学内容`)
};

const en_featured_metadescription1 = /** @type {(inputs: Featured_Metadescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From math animations to English games, AI assistants help teachers create innovative educational content`)
};

const es_featured_metadescription1 = /** @type {(inputs: Featured_Metadescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde animaciones matemáticas hasta juegos de inglés, los asistentes IA ayudan a los profesores a crear contenido educativo innovador`)
};

/**
* | output |
* | --- |
* | "From math animations to English games, AI assistants help teachers create innovative educational content" |
*
* @param {Featured_Metadescription1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const featured_metadescription1 = /** @type {((inputs?: Featured_Metadescription1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Featured_Metadescription1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_featured_metadescription1(inputs)
	if (locale === "en") return en_featured_metadescription1(inputs)
	return es_featured_metadescription1(inputs)
});
export { featured_metadescription1 as "featured_metaDescription" }